import React from 'react';
import PropTypes from 'prop-types';
import OptionListStyles from './optionListStyles';

const OptionListItem = props => {
  return <option value={props.value}>{props.label}</option>;
};

OptionListItem.propTypes = {
  label: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const OptionList = props => {
  return (
    <OptionListStyles {...props}>
      {React.Children.map(props.children, link => ({
        ...link,
        props: {
          ...link.props,
          name: props.name,
        },
      }))}
    </OptionListStyles>
  );
};

OptionList.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
};

OptionList.Item = OptionListItem;

export default OptionList;
